import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function AboutUsHero() {
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundImage:
          "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)",
        ...theme.applyStyles("dark", {
          backgroundImage:
            "radial-gradient(ellipse 70% 110% at 50% -20%, hsl(210, 100%, 16%), transparent)",
        }),
      })}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 14, sm: 20 },
          pb: { xs: 0, sm: 0 },
        }}
      >
        <Stack
          spacing={2}
          useFlexGap
          sx={{ alignItems: "center", width: { xs: "100%", sm: "70%" } }}
        >
          <Typography
            variant="h1"
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              fontSize: "clamp(3rem, 10vw, 3.5rem)",
            }}
          >
            Acerca&nbsp;de&nbsp;
            <Typography
              component="span"
              variant="h1"
              sx={(theme) => ({
                fontSize: "inherit",
                color: "primary.main",
                ...theme.applyStyles("dark", {
                  color: "primary.light",
                }),
              })}
            >
              nosotros
            </Typography>
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "text.secondary",
              width: { sm: "100%", md: "80%" },
            }}
          >
            Impulsados por la pasión por el espacio y la ingeniería mexicana,
            ENMICE (Encuentro Mexicano de Ingeniería en Cohetería Experimental)
            nace en 2020 como proyecto durante la pandemia, fundada por el Ing.
            Ramón Córdova, Ing. Felipe Ávila, Mtro. Ariel Gómez, Ing. Walter
            Ahrens y M.C. Jonathan Castillo. El objetivo fue claro desde el
            inicio: fomentar y reconocer el desarrollo de la cohetería
            experimental de alta potencia en México, así como consolidar una
            comunidad científica y tecnológica nacional.
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "text.secondary",
              width: { sm: "100%", md: "80%" },
            }}
          >
            Gracias al compromiso de aliados estratégicos, instituciones
            educativas, patrocinadores y jóvenes talentos de todo el país,
            ENMICE se ha convertido en un referente para quienes desean
            incursionar o profesionalizarse en el sector aeroespacial mexicano,
            esepecíficamente en el desarrollo de vehículos lanzadores.
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "text.secondary",
              width: { sm: "100%", md: "80%" },
            }}
          >
            Hoy, ENMICE es mucho más que un encuentro: es un movimiento que
            conecta, forma e impulsa a la nueva generación espacial de México
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
